import React from 'react';
import {
  Inbox, List, Building2, Mail, Sparkles, SlidersHorizontal,
} from 'lucide-react';

// Same destinations and icons as the desktop sidebar.
const ITEMS = [
  { key: 'dashboard', icon: Inbox, label: 'Today' },
  { key: 'intelligence', icon: List, label: 'Stories' },
  { key: 'companies', icon: Building2, label: 'Companies', alsoActiveOn: ['watchlist'] },
  { key: 'briefs', icon: Mail, label: 'Briefs' },
  { key: 'ai', icon: Sparkles, label: 'AI' },
  { key: 'settings', icon: SlidersHorizontal, label: 'Settings' },
];

function MobileNav({ view, setView, alertCount = 0 }) {
  return (
    <nav
      aria-label="Main"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#0f141b] border-t border-white/[0.06] px-1 pb-[env(safe-area-inset-bottom)]"
    >
      <div className="flex items-stretch justify-around h-14">
        {ITEMS.map(({ key, icon: Icon, label, alsoActiveOn }) => {
          const active = view === key || Boolean(alsoActiveOn?.includes(view));
          const showBadge = key === 'dashboard' && alertCount > 0;
          return (
            <button
              key={key}
              type="button"
              onClick={() => setView(key)}
              aria-current={active ? 'page' : undefined}
              className={`relative flex-1 min-w-0 flex flex-col items-center justify-center gap-0.5 transition ${
                active ? 'text-white' : 'text-[#8d98ab]'
              }`}
            >
              {active && <span className="absolute top-0 left-1/2 -translate-x-1/2 w-6 h-0.5 rounded-full bg-[#6b97ff]" />}
              <span className="relative">
                <Icon size={19} strokeWidth={active ? 2.1 : 1.8} className={active ? 'text-[#6b97ff]' : ''} />
                {showBadge && (
                  <span className="absolute -top-1.5 -right-2.5 min-w-[16px] h-4 px-1 rounded-full bg-[#ff7a70] text-[#1a0d0c] text-[10px] font-semibold flex items-center justify-center">
                    {alertCount > 9 ? '9+' : alertCount}
                  </span>
                )}
              </span>
              <span className="text-[10.5px] font-medium tracking-tight max-w-full whitespace-nowrap">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}

export default MobileNav;
